import SearchSelect from "@ui-components/SearchSelect";
import React, {useContext, useState} from "react";
import CountryContext from "../CountryContext";
import {FormattedMessage} from "react-intl";
import {useIntl} from "react-intl";
import _ from "lodash";


/**
 * This component is used as select on tables that needs
 * to fetch data from the backend.
 * It integrates with mu-tables events to refresh the table
 * based on selected filters.
 */
const COMPONENT_STYLE_OVERRIDE = {
    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: "2px 8px",
    }),
    clearIndicator: (provided, state) => ({
        ...provided,
        padding: "2px 8px",
    }),
    control: (provided, state) => ({
        ...provided,
        borderRadius: "1.3rem",
        borderColor: "transparent",
        boxShadow: "none !important",
        "&:hover": {
            borderColor: "transparent",
        },
        backgroundColor: "transparent",
        minHeight: "33px",
        cursor: "pointer",
    }),
    singleValue: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    placeholder: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    input: (provided, state) => ({
        input: {
            border: 0,
            outline: 0,
            boxShadow: "none !important",
        },
    }),
}

const SuggestedUsersBooleanTableFilter =
    ({
         columnDef,
         onFilterChanged,
     }) => {
    const intl = useIntl();

    // context
    const {country: {code}} = useContext(CountryContext);

    // state
    const [selected, setSelected] = useState(null);


    return (
        // @ts-ignore
      <div className={"mb-6"}>
      <SearchSelect
        options={[
            {value: "true", label: _.capitalize(intl.formatMessage({id: 'yes'}))},
            {value: "false", label: _.capitalize(intl.formatMessage({id: 'no'}))},
        ]}
        onChange={(selected) => {
            onFilterChanged((columnDef).tableData.id, selected?.value);
            setSelected(selected);
        }}
        value={selected}
        isMulti={false}
        mainStyle="border-2 border-kerakoll-400 mt-1 mb-0"
        componentStyle={COMPONENT_STYLE_OVERRIDE}
        noOptionsMessage={() => <FormattedMessage id="type_to_search"/>}
        isClearable={true}
        isSearchable={false}
      />
      </div>
    )
}

export default SuggestedUsersBooleanTableFilter